import graph from './graph';

export default {
    //cookie設定
    expirationDate:"2m",
    link: {
        "toshiba": {
            "url": "https://www.global.toshiba/jp/top.html",
            "contents": {
                "data": require("@/assets/Toshiba_Logo_Red_RGB.png"),
                "type": "img/gif"
            },
        },
        "ess": {
            "url": "https://www.global.toshiba/jp/top.html",
            "contents": {
                "data": "東芝トップページ",
                "type": "text"
            },
        },
        "privacy": {
            "url": "https://www.global.toshiba/jp/privacy/corporate.html",
            "contents": {
                "data": "個人情報保護方針",
                "type": "text"
            },
        },
        "copyright": {
            "url": "https://www.global.toshiba/jp/c_right/corporate.html",
            "contents": {
                "data": "Copyright © " +
                    new Date().getFullYear() +
                    " TOSHIBA CORPORATION, All Rights Reserved.",
                "type": "text"
            },
        },
    },
    graph,
}